import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import ContactCardSchema from './schema';
import ContactCardView from './ContactCardView';
import type { ContactCardData } from './ContactCardView';

type ContactCardEditProps = {
  data: ContactCardData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: ContactCardData) => void;
};

const ContactCardEdit = (props: ContactCardEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = ContactCardSchema({ intl });

  return (
    <>
      <ContactCardView data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default ContactCardEdit;
